module.exports = __webpack_public_path__ + "janne_square-616567c78093893b32d55a5c79a8cc59.png";


//////////////////
// WEBPACK FOOTER
// ./assets/media-images/se/janne_square.png
// module id = 1196
// module chunks = 1 2